import { useState, useEffect } from 'react';
import languages from './languages.json';

type Language = 'en' | 'es';
type Translations = typeof languages.en;

export const useLanguage = () => {
  const [lang, setLang] = useState<Language>('en');

  useEffect(() => {
    const browserLang = navigator.language.split('-')[0];
    setLang(browserLang === 'es' ? 'es' : 'en');
  }, []);

  const t: Translations = languages[lang];

  return { lang, setLang, t };
};
